export default {
  navbar: {
    Home: "Home",
    Dashboard: "Dashboard",
    My: "My",
    Support: "Support",
    Projects: "Projects",
    ProjectCount: "Project count",
    Admin: "Admin",
    Library: "Library",
    ProjectList: "Project list",
    Profile: "Profile",
    SiteObservation: "Site observation",
    GenerateReport: "Generate reports",
    BaselineConfig: "Baseline configuration",
    MonthlyBaseline: "Monthly baseline",
    EquipmentSpecs: "Equipment specs",
    BaselinePreview: "Baseline preview",
    Analysis: "Analysis",
    Menu: "Menu",
    Objective: "Objective",

    RetrofitSolution: "Retrofit solution",
    ExistingEqptSpecs: "Existing equipment specs",

    Baseline: "Baseline",
    Proposed: "Proposed",
    SetupOperatingCondition: "Setup operating condition",
    DefineNewEquipment: "Define new equipment"
  },

  ctrl: {
    Login: "Login",
    Logout: "Logout",
    Register: "Register",
    ModifyPassword: "Modify password",
    Language: "Language",
    UserGuide: "User guide",
    UserSetting: "User setting",
    Delete: "Delete",
    Cancel: "Cancel",
    Edit: "Edit",
    Copy: "Copy",
    Paste: "Paste",
    Proceed: "Proceed",
    Save: "Save",
    Back: "Back",
    Next: "Next",
    Confirm: "Confirm",
    Close: "Close",
    Exit: "Exit",
    All: "All",
    Clear: "Clear",
    Yes: "Yes",
    No: "No",
    Template: "Template",
    AddEquipment: "Add equipment",
    DownloadReport: "Download report",
    MultiInput: "Multi-point input",
    AddBaseline: "Add baseline",
    Estimate: "Estimate",
    Calculate: "Calculate",
    ViewDetail: "View detail",
    CollapseDetail: "Collapse detail",
    Generate: "Generate",
    Input: "Input",
    Reconfigure: "Reconfigure",
    Optimize: "Optimize",
    CurrentYear: "Current year",
    LastYear: "Last year",
    NextYear: "Next year",
    Last12Months: "Last 12 months",
    Next12Months: "Next 12 months",
    selectClearAll: "Select / Clear all",
    View: "View"
  },

  label: {
    ProjectName: "Project name",
    Multiple: "Multiple",
    BuildVertical: "Build vertical",
    DataCollectionMont: "Data collection month",
    CurrencyLabel: "Currency label",
    TemperatureUnit: "Temperature unit",
    Unit: "Unit",
    Time: "Time",
    Hour: "Hour",
    Hours: "Hours",
    Day: "Day",
    Days: "Days",
    Month: "Month",
    Months: "Months",
    Year: "Year",
    Years: "Years",

    ChillerType: "Chiller type",
    PumpingConfiguration: "Pumping configuration",
    Primary: "primary",

    RatedPower: "Rated power",
    RatedInputPower: "Rated input power",
    RatedCoolingCapacity: "Rated cooling capacity",
    Frequency: "Frequency",
    MaxHz: "Max frequency",
    MinHz: "Min frequency",
    RatedFrequency: "Rated frequency",
    MaxFrequency: "Upper limit operating frequency",
    MinFrequency: "Lower limit operating frequency",
    RatedHeatRejectionCapacity: "Rated heat rejection capacity",

    VFD: "VFD",
    VariableFrequencyDrive: "Variable frequency drive",

    AssetLabels: "Asset labels",
    UnitNumber: "Number of units (#)",
    PumpType: "Pump type",
    DateCommissioned: "Date commissioned",
    Degradation: "Degradation rate",
    Brand: "Brand",
    Model: "Model",
    Remarks: "Remarks",

    RatedInputPower_100: "Rated input power at 100%",
    RatedInputPower_100_ct: "Rated input power at 100% per CT",

    RatedCoolingCapacity_100: "Rated cooling capacity at 100%",
    RatedHeatRejectionCapacity_100: "Rated heat rejection capacity at 100%",

    DesignCondenserWaterEnteringTemp: "Design condenser water entering temp",
    TotalCellPerCoolingTower: "Total cell per cooling tower",
    ActualCondenserWaterEnteringTemp: "Actual condenser water entering temp",
    TotalCellPerDryCooler: "Total cell per dry cooler",
    DryCoolerType: "Dry cooler type",
    RatedCapacity: "Rated capacity",
    EnergyType: "Input energy",

    BaselineName: "Baseline name",
    ApplicableMonths: "Applicable months",

    DataTable: "Data table",
    ChartView: "Chart view",
    CoolingLoad: "Cooling load",
    Total: "Total",

    Observation: "Observation",
    Photo: "Photo",
    Maximum6: "Maximum 6",

    ChillerConfiguration: "Chiller configuration",
    BoilerConfiguration: "Boiler configuration",
    CoolingSystemConfiguration: "Cooling system configuration",

    MaxHeatingCapacity: "Coldest month max heating capacity",
    EffectiveCapacity: "Coldest month effective capacity",
    BoilerEfficiency: "Boiler efficiency",
    hotWaterTemp: "Required temperature for hot water supply",

    EnergyCarbonIntensity: "Energy carbon intensity",
    FuelCalorificValue: "Fuel calorific value (CV)",

    ZeroHeatingOAT: "Outdoor temperature at zero heating demand",
    MaxHeatingOAT: "Outdoor temperature at maximum heating demand",
    DesiredHotWaterTemp: "Desired hot water temperature",
    BoilerUtilizationColdestTemp: "Boiler utilization at coldest temperature",
    ColdestWater: "Coldest incoming water temperature",

    WaterDemandPerDay: "Average water demand per person",
    UserNumber: "Number of occupants",
    liters: "liters",

    ChillerModel: "Chiller model",
    RefChillerModel: "Reference chiller model",
    WeatherProfile: "Weather profile",
    EstimatePath: "Estimate path",
    AvailableData: "Available data",
    CondenserWaterTempProfile: "Condenser water temperature profile",

    DesignCondenserSupplyTemp: "Design condenser water supply temp",
    DesignCondenserAirSupplyTemp: "Design condenser air supply temp",
    DesignChilledWaterTemp: "Design chilled water supply temp",
    OutDoorDryBulbTemp: "Outdoor dry bulb temp",
    ChilledWaterSupplyTemp: "Chilled water supply temp",
    TowerApproachTemp: "Cooling tower approach temp",
    ActualCondenserSupplyTemp: "Actual condenser water supply temp",
    ActualCondenserAirSupplyTemp: "Actual condenser air supply temp",
    ActualChilledWaterSupplyTemp: "Actual chilled water supply temp",
    MinCondenserWaterSupplyTemp: "Min condenser water supply temp",
    DesignSourceWaterTemp: "Design source water supply temp",
    DesignSourceAirTemp: "Design source air supply temp",
    DesignHotWaterSupplyTemp: "Design hot water supply temp",

    ChillerRunningNumber: "Number of chiller currently running",
    CoolingCapacityRange: "Cooling capacity range",
    AllRightsReserved: "All Rights Reserved.",

    From: "From",
    To: "To",

    Cluster: "Cluster",
    ClusterNum: "Number of clusters",
    ClusterName: "Cluster name",
    WeekPeriod: "Week period",
    AssociationMethod: "Association method",

    MaxCoolingLoadBaseline: "Max cooling load in baseline",
    MaxCoolingLoad: "Max cooling load",
    AssociatedChiller: "Associated chiller",
    MaxRunningNumber: "Max running number",
    Chiller: "Chiller",
    AssociatedHeatPump: "Associated heat pump",

    RetrofitPreferences: "Retrofit preferences",

    CAPEX: "CAPEX (Project Price incl. Installation)",
    OverallProjectPrice: "Overall project price",
    USFXRate: "US FX rate",

    Option: "Option",
    Solution: "Solution",

    GeneralInfo: "General information",
    TechSpec: "Technical specification",
    PerformanceConditions: "Performance conditions",
    EcatPerformanceInput: "eCAT performance input",
    Capacity: "Capacity",
    CoolingCapacity: "Cooling capacity",
    SerialNumber: "Serial number",
    ElectricalLoad: "Electrical load",

    Category: "Category",
    EfficiencyImprovement: "Efficiency improvement",
    CostSavingsPerYear: "Total cost savings per year",
    ROI: "Return on investment",
    PaybackPeriod: "Discounted payback period",
    SimplePayback: "Simple payback period",

    Estimated: "Estimated",
    Actual: "Actual",

    Like: "Like",
    Dislike: "Dislike",

    OptionDetails: "Option details",
    TotalEnergySavings: "Total energy savings per year",
    RetrofitCost: "Retrofit cost",
    ExpectedYears: "Asset life cycle period",
    NPV: "Net present value",

    ProjectIntroduction: "Project introduction",
    Assumptions: "Assumptions",
    AssumptionsConsider: "Assumptions consider for analysis",
    AssumptionsAnalysis: "Assumptions for analysis",

    ChillerPlant: "Chiller plant",
    Configuration: "Configuration",
    PeakBuildingLoad: "Peak building cooling load",
    OAT: "Outdoor air temp",
    EnergyConservationMeasures: "Energy conservation measures",

    DesignFlowRate: "Design flow rate",
    RatedDesignFlowRate: "Rated (design) flow rate",
    DesignPressureHead: "Design pressure head",
    PressureHead: "Pressure head",
    VFDFitted: "VFD fitted",

    DesignConditions: "Design conditions",
    ProjectSettings: "Project settings",

    Tariff: "Tariff",
    EnergyTariff: "Energy tariff",
    MonthlyTariff: "Monthly tariff",
    OperatingPeriod: "Operating period",
    RunningMonths: "Running months",

    Recommendation: "Recommendation",
    Benefit: "Benefit",

    MonthlyRunningDays: "Operating days on {type}",
    BaselineMonth: "Baseline month",
    EstimatedMonth: "Estimated month",
    EstimatedPower: "Estimated power",
    ElectricityCarbonIntensity: "Carbon intensity of electricity",
    PlantEfficiency: "Plant efficiency",
    EfficienctyUnit: "Efficiency unit",

    Type: "Type",
    SellingPricePrtUnit: "Selling price per unit",
    ApplicableChiller: "Applicable chiller",
    NoOfFansCT: "No. of fans / CT",

    Load: "Load",
    Power: "Power",
    InputPower: "Input power",

    TotalEnergyImprovement: "Total energy improvement",
    EquipmentStatus: "Equipment status",

    SetRecommended: "Set as recommended",
    CancelRecommendation: "Cancel recommendation",

    Optional: "Optional",

    RetrofitCostConfiguration: "Retrofit cost configuration",
    PaybackPeriodSummaryNPV: "Payback period summary and NPV",

    EquipmentDetailsProposed: "Equipment details proposed",
    GenerateECMReport: "Generate ECM report",

    PeakMaxCoolingLoad: "Peak max cooling load",
    OffPeakMaxCoolingLoad: "Off-peak max cooling load",

    ProposedCoolingCapacity: "Proposed chiller cooling capacity",

    ChillerPlantTotal: "Chiller plant total",

    EnergySavingsPerYear: "Energy savings per year",

    CapitalAssetRetrofitInvestmentCost: "Capital asset retrofit investment cost",
    EstimatedProjectValue: "Estimated project value",
    ActualProjectValue: "Actual project value",

    ProjectDetails: "Input details",

    ElectricalDB: "Electrical DB",
    PlantControlSys: "Plant control system",

    QuickSelect: "Quick select",
    ClusterMonth: "Cluster months",

    MonthlyCoolingLoad: "Monthly cooling load",
    MonthlyPower: "Monthly power",

    Default: "Default",
    ReconfigureSolution: "Reconfigure solution",
    ReconfiguredSolution: "Reconfigured solution",

    SingleChilledWaterTemp: "Single chilled water temperature",
    ECatPerformanceData: "Cluster temperature details", //"eCAT performance data" --260909,
    CopyInputECATPerformance: "Copy input eCAT performance",

    CopyFrom: "Copy from",
    PasteInto: "Paste into",

    PredictedUtilization: "Predicted utilization",
    UserConfirmedUtilization: "User confirmed utilization",

    ProjectObjective: "Project objective",
    ChillerEfficiency: "Chiller efficiency",
    ChillerPlantEfficiency: "Chiller plant efficiency",
    HeatingEfficiency: "Heating efficiency",
    HeatingPlantEfficiency: "Heating plant efficiency",
    ChillerHeatingEfficiency: "Chiller & heating efficiency",
    ChillerRetrofit: "Chiller retrofit",
    ChillerPlantRetrofit: "Chiller plant retrofit",
    HeatingElectricRetrofit: "Boiler to heat pump retrofit",
    HeatPumpRetrofit: "Heat pump retrofit",
    IntegratedRetrofit: "Integrated cooling & heating plant retrofit",

    ManualInput: "Manual input",
    AutoSoon: "Auto soon",

    AvailableDesignTemp: "Available design temp",
    ChillerSelection: "Chiller selection",
    NewChillerSeries: "New chiller series",
    ECATLibraryType: "E-CAT library type",
    PerformanceTable: "Performance table",
    ChillerName: "Chiller name",
    StandardECAT: "Standard eCAT",
    EstimatedECAT: "Estimated eCAT",
    CustomizedECAT: "Customized eCAT",
    CustomCapacity: "Custom capacity",

    OperatingDayType: "Operating day type",
    MonthlyOperatingDays: "Monthly operating days",
    OperatingSiteChiller: "Operating site chiller",
    ProxyChillerModel: "Proxy chiller model",
    ManufacturingRegion: "Manufacturing source",
    CompressorType: "Compressor type",
    BearingType: "Bearing type",
    VFDType: "VFD type",
    AvailableProxyModels: "Available proxy models",
    NominalCapacity: "Nominal capacity",
    PointsCalibration_4: "4 points calibration",
    PartLoadCalibration_note: "Only factory design-condition data is supported for part-load calibration.",

    HourlyChillerOperation: "Hourly chiller operation",
    OperatingChillerCount: "Operating chiller count",
    LoadRatio: "Load ratio",
    CalculatedOperatingLoad: "Calculated operating load",

    NewChillerType: "New chiller type",

    ProposedEfficiency: "Proposed efficiency",
    RetrofitConfiguration: "Retrofit configuration",
    ROI_NPVSummary: "ROI & NPV summary",
    AssumptionOfferings: "Assumption & offerings",

    ProposedRunningNumber: "Proposed number of running equipment",

    ProposedSummary: "Proposed summary",
    BaselineEfficiency: "Baseline efficiency",
    AnnualizedAverageROI: "NPV-based annualized average ROI",

    SelectProposedScenarios: "Select proposed scenarios",
    BaselineHourlyCoolingLoad: "Baseline hourly cooling load",

    ProxyChillerFilter: "Proxy chiller filter",

    ChillerEfficiency_100: "Chiller efficiency at 100%",
    DegradedEfficiency_100: "Degraded efficiency at 100%",

    CommercialInput: "Commercial input",

    SiteSettings: "Site settings",
    ExistingBoilerSystem: "Existing boiler system",
    HeatingApplication: "Heating application",

    PerformanceModel: "Performance model",
    HeatingCapacityPerUnit: "Rated heating capacity per unit",
    BaselineSetup: "Baseline setup",
    OperatingMonths: "Operating months",
    OperatingBoiler: "Operating boiler",
    BoilerNumAtColdest: "Number of running boiler at coldest temp",
    singlePriceNote: "Used to estimate project CAPEX (incl. installation).",

    BoilerDetails: "Boiler details",
    HeatPumpCfg: "Heat pump configuration",
    HeatPumpSourceType: "Heat pump source type",
    HotWaterSupplyTemp: "Hot water supply temp",
    ActualHWSTemp: "Actual hot water supply temp",
    SingleHWSTemp: "Single hot water supply temp",
    WaterSourceTemp: "Water source temp",
    GroundLoop: "Ground loop",
    HeatingCapacity: "Heating capacity",
    RatedHeatingCapacity: "Rated heating capacity",
    HeatPumpSelection: "Heat pump selection",
    HeatPumpName: "Heat pump name",
    HeatPumpModel: "Heat pump model",
    ModelNumber: "Model number",
    AirSourceTemp: "Air source temp",
    DesignAirSourceTemp: "Design air source temp",
    DesignEWSTemp: "Design evaporator water supply temp",
    RatedCOP_100: "Rated COP at 100%",

    ProposedHeatPumpCOP: "Proposed heat pump COP",
    MaxHeatingLoad: "Max heating load",
    ProposedHeatPumpCapacity: "Proposed heat pump capacity per unit",
    CostAssumptionInputs: "Cost & assumption inputs",
    ExistingAnnualCost: "Existing annual cost",
    ProposedAnnualCost: "Proposed annual cost",
    Escalation: "Escalation"
  },

  option: {
    New: "New",
    Existing: "Existing",
    Remove: "Remove",

    LARGE_OFFICE: "Large office",
    MEDIUM_OFFICE: "Medium office",
    SMALL_OFFICE: "Small office",
    RESTAURANT: "Restaurant",
    HOSPITAL: "Hospital",
    HOTEL: "Hotel",
    MALL: "Mall",
    SCHOOL: "School",
    EDUCATIONAL_INSTITUTIONS: "Educational institutions",
    RESIDENTIAL: "Residential",
    OTHERS: "Others",

    Month: "Month",
    Jan: "Jan",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Apr",
    May: "May",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Aug",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dec",

    plant: "Chiller plant",
    chiller: "Chiller",
    pump: "Pump",
    coolingTower: "Cooling tower",
    piping: "Piping",
    dryCooler: "Dry cooler",
    controlSys: "Control system",
    boiler: "Boiler",
    heatPump: "Heat pump",
    other: "Other",

    WaterCooled: "Water-cooled",
    AirCooled: "Air-cooled",
    WaterCooled_AirCooled: "Water-cooled & air-cooled",

    chwp: "Chilled water pump",
    chwpPrimary: "Chilled water pump - Primary pump",
    chwpSecondary: "Chilled water pump - Secondary pump",
    PrimaryPump: "Primary pump",
    SecondaryPump: "Secondary pump",
    cwp: "Condenser water pump",
    CondenserWater: "Condenser water",
    ChilledWaterPrimary: "Chilled water primary system",
    ChilledWaterPrimarySecondary: "Chilled water primary - secondary system",
    CondenserWaterSys: "Condenser water system",
    CommonHeader: "Common header",
    Dedicated_1_1: "Dedicated 1-1",

    wcCentri: "WC - Centri",
    wcScrew: "WC - Screw",
    wcRecip: "WC - Recip",
    wcScroll: "WC - Scroll",
    acScrew: "AC - Screw",
    acScroll: "AC - Scroll",
    acRecip: "AC - Recip",

    Centrifugal: "Centrifugal",
    Screw: "Screw",
    Scroll: "Scroll",
    Reciprocating: "Reciprocating",
    Rotary: "Rotary",

    Degradation_25: "0.25% per year",
    Degradation_50: "0.50% per year",
    Degradation_75: "0.75% per year",
    Degradation_100: "1.00% per year",

    GoodCondition: "Good condition",
    AverageCondition: "Average condition",
    BelowAverageCondition: "Below average condition",
    BadCondition: "Bad condition",

    SpaceCooling: "Space cooling",
    SpaceHeating: "Space heating",
    DomesticHotWater: "Domestic hot water",
    SHandDHW: "Space heating & domestic hot water",

    GasFuel: "Gas fuel",
    LiquidFuel: "Liquid fuel",
    ElectricalEnergy: "Electrical energy",

    DryBulbTemp: "Mean dry bulb temp",
    WetBulbTemp: "Mean wet bulb temp",
    WaterTemp: "Water temp",

    MaxDryBulbTemp: "Mean max dry bulb temp",
    MinDryBulbTemp: "Mean min dry bulb temp",
    AvgDryBulbTemp: "Mean avg dry bulb temp",
    MaxWetBulbTemp: "Mean max wet bulb temp",
    MinWetBulbTemp: "Mean min wet bulb temp",
    AvgWetBulbTemp: "Mean avg wet bulb temp",

    PeakWaterTemp: "Peak water temp",
    OffPeakWaterTemp: "Off-peak water temp",
    AvgTemp: "Average temp",

    ColdWaterTemp: "Incoming cold water temp",

    CondenserWaterSupplyTemp: "Condenser water supply temp",
    MeanCondenserWaterSupplyTemp: "Mean condenser water supply temp",
    MeanMaxCWSTemp: "Mean max condenser water supply temp",
    MeanAvgCWSTemp: "Mean avg condenser water supply temp",

    CondenserAirSupplyTemp: "Condenser air supply temp",
    MeanCondenserAirSupplyTemp: "Mean condenser air supply temp",
    MeanMaxCASTemp: "Mean max condenser air supply temp",
    MeanAvgCASTemp: "Mean avg condenser air supply temp",

    PathA: "Based on cooling load",
    PathB: "Based on energy consumption",
    Method1: "1M hourly profile",
    Method3: "12M hourly profile",

    HeatingPathA: "Boiler capacity - only approach",
    HeatingPathB: "Boiler capacity with energy data integration",

    Off: "Off",
    Peak: "Peak",
    OffPeak: "Off-peak",
    AllPeak: "All peak",
    PeakPeriod: "Peak period",
    OffPeakPeriod: "Off-peak period",
    WeekdayPeak: "Weekday peak",
    WeekdayOffPeak: "Weekday off-peak",
    WeekendPeak: "Weekend peak",
    WeekendOffPeak: "Weekend off-peak",

    AllCity: "All city",
    MegaCity: "Mega city",
    NonMegaCity: "Non-mega city",

    Win: "Win",
    PipeLine: "Pipeline",
    TotalPipeline: "Total pipeline",
    ActualOrder: "Actual order",
    ExpectedOrder: "Expected order",

    All: "All",
    Values: "Values",
    Projects: "Projects",
    Count: "Count",
    WinProbability: "Win Probability",

    SingleCluster: "Single cluster",
    MultipleCLuster: "Multiple clusters",

    HighestEfficiencyImprovement: "Highest efficiency improvement",
    LowestInvestment: "Lowest investment",
    ShortestPaybackPeriod: "Shortest payback period",

    Max: "Max",
    Min: "Min",
    Avg: "Avg",

    StepMonthlyCoolingLoad: "Monthly cooling load",
    StepEstimateCoolingLoad: "Estimate cooling load",
    StepEstimatePower: "Estimate chiller power",
    StepEstimatePowerLoad: "Estimate chiller power",
    EstimateChillerCount: "Estimate chiller count",

    OperatingCalendar: "Operating calendar",
    OperatingHours: "Operating hours",
    OperatingLoad: "Operating load",
    ReferChiller: "Reference chiller",
    MonthlyChillerCount: "Monthly chiller count",

    RunningHours: "Running hours",
    EnergyConsumption: "Energy consumption",
    ChillerEnergyConsumption: "Chiller energy consumption",

    AuxiliaryPower: "Auxiliary power",
    PlantEquipment: "Plant equipment",
    ChillerPower: "Chiller power",
    CHWPPower: "Chilled water pump power",
    CWPPower: "Condenser water pump power",
    CTPower: "Cooling tower power",

    WeightedAvgEfficiency: "Weighted average efficiency",
    WeightedAvgCoolingLoad: "Weighted average cooling load",
    WeightAvgPower: "Weighted average power",
    RunningHrsPerDay: "Running hours per day",
    ActualWeightedAveragePower: "Actual weighted average power",

    AnnualCost: "Annual cost",
    AnnualEscalation: "Annual cost escalation",
    IncentiveRebate: "Incentive & rebate",

    ProposeConfig: "Proposed configuration",

    Weekday: "Weekday",
    Weekend: "Weekend",
    WholeWeek: "Whole week",

    Automatic: "Automatic",
    Manual: "Manual",
    Reconfigured: "Reconfigured",
    AlgorithmSelectsConfig: "Algorithm selects configuration",
    UserSelectsConfig: "User selects configuration",

    ManualCluster: "Manual cluster",
    DigitalECAT: "Digital eCAT",

    BoilerUtilization: "Boiler utilization",
    HeatingLoad: "Heating load",
    MonthlyHeatingLoad: "Monthly heating load",
    EffectiveMonthly: "Effective monthly heating energy",
    EnergyCharges: "Energy charges",
    CO2Emissions: "CO₂ emissions",
    GasFuelConsumption: "Gas fuel consumption",
    LiquidFuelConsumption: "Liquid fuel consumption",
    ElectricalEnergyConsumption: "Electrical energy consumption",
    GasFuelCharges: "Gas fuel charges",
    LiquidFuelCharges: "Liquid fuel charges",
    ElectricalEnergyCharges: "Electrical energy charges",

    Standard: "Standard",
    Ceramic: "Ceramic",
    Magnetic: "Magnetic",
    VFD: "VFD",
    NonVFD: "Non-VFD",
    ClusterMonths: "Cluster months",

    Chiller: "Chiller",
    HeatPump: "Heat pump",
    WaterSource: "Water-source",
    AirSource: "Air-source",

    ConstantEfficiency: "Constant efficiency",
    UserDefinedCurve: "User defined curve",
    BoilerOperation: "Boiler operation",
    MonthlyEnergyConsumption: "Monthly energy consumption",
    AvgHeatingLoad: "Weighted avg heating load",
    MonthlyBoilerCount: "Monthly boiler count",
    BoilerEnergyConsumption: "Boiler energy consumption",
    EstimateBoilerCount: "Estimate boiler count",
    EstimateHeatingLoad: "Estimate heating load",
    EstimateEnergyConsumption: "Estimate energy consumption",

    ECatLib: "e-CAT library",
    OwnLib: "Own library"
  },

  msg: {
    imageOnly: "Only image files are allowed",
    comingSoon: "Coming soon.",
    Success: "Success",
    FailedRetry: "Failed! Please try again",
    DeleteEquip: "Delete equipment",
    DeleteWarning: "Do you confirm to delete: ",
    DeleteBaseline: "Delete baseline",
    Warning: "Warning",
    UnsavedWarning: "Unsaved changes will be lost if you exit the current page.",
    SaveBeforeProceeding: "Do you want to save your changes before proceeding?",
    NoOptionsSelected: "No options selected",
    AlreadyExists: "Already exists",
    Saving: "Saving...",
    Generating: "Generating...",
    Loading: "Loading...",
    DeletingFiles: "Deleting files...",
    CompressingFiles: "Compressing files...",
    UnsupportedImageTypeTitle: "Unsupported files skipped",
    UnsupportedImageTypesDiscarded: "Skipped file types",
    UploadingFiles: "Uploading files...",
    NetworkError: "Network anomaly, operation failed",
    NetworkLimit: "Network anomaly, function limited",
    Over24HoursTips: "Total time over 24 hours",
    Over24HoursToast: "Total time of peaks and off-peak over 24 hours",
    CityChanged: "City has been changed from {curtCity} to {newCity}.",
    OverrideWeatherData: "<br>Do you want to override the existing weather profile data using the newly selected city OAT?",
    ProjectNameIsEmpty: "Project name can not be empty",
    CityIsEmpty: "City can not be empty",
    SelectReferModel: "Please select a reference model",
    InputDataIntoReferenceChiller: "Input the above data into reference chiller",
    PeriodCanNotAllOff: "Period can not be all Off",
    CanNotBlank: "Can not be blank",
    CanNotBlankZero: "Can not be blank or 0",
    CanNotAllBlank: "Can not be all blank",
    CanNotAllBlankZero: "Can not be all blank or all 0",
    NetworkTimeout: "Network timeout! Please try again",
    RequestError: "Request error",
    LoginExpired: "Login expired",
    AccessDenied: "Access denied",
    ResourceNotExist: "The requested resource does not exist",
    ServerError: "Service error",
    GatewayError: "Gateway Error",
    ServiceUnavailable: "Service unavailable",
    UserNotExist: "User does not exist",
    WrongPassword: "Wrong password",
    NotActivate: "Account not activated",
    DeleteCluster: "Delete cluster",
    Estimating: "Estimating...",
    Analyzing: "Analyzing...",
    Calculating: "Calculating...",
    UnsavedAfterEstimate: "Unsaved data entered after the last estimate will be lost if you leave this page.",
    DiscountRateTips: "Discount rate determines expected investment returns, in absence of which inflation rate applies.",
    CalculateROINotice: "Please click '1. Input' to complete the retrofit cost and 'Calculate ROI' first.",
    ConfirmFxRate: "Please confirm US FX Rate",
    SetRecommended: "Set {name} as recommended",
    SelectCardPasteInto: "Please select the card to paste into.",
    Copied: "Copied to clipboard",
    Pasted: "Pasted",
    OverwriteOption: "Regenerate will overwrite all existing solution data and remove generated report.",
    OverwriteOptionAll: "You have configured optimize solution. <br/>Regenerate will overwrite all existing solution data and remove generated report.",
    RefreshRequired: "Refresh Required",

    ReAnalysisPre: "To generate or update Baseline Preview, first refresh the Cooling Load and Power Analysis in Monthly Baseline, then manually refresh Baseline Preview.",

    ReAnalysisHeating: "To generate or update Baseline preview, refresh heating load and power analysis first in monthly baseline, then refresh Baseline preview manually.",

    PleaseSelectObjective: "Please select objective",
    HeatingOnlySupportsPre: "The heating efficiency module currently only supports pre-retrofit",
    CompleteBaselineConfigFirst: "Please complete the baseline configuration in pre-retrofit first.",
    CompleteBaselineAnalysisFirst: "Please complete the baseline analysis in pre-retrofit first",

    AcceptOneUtilization: "Accept Predicted utilization as User confirmed utilization?",
    AcceptAllUtilization: "Accept all Predicted utilization as User confirmed utilization?",
    NoReportGenerate: "No report, please enter the project to generate.",

    DependencyHint: "Dependency hint:",
    DryBulbDependencyCooling: "Dry bulb temperature is used to estimate the cooling load profile.",
    WeatherDependencyCooling:
      "For water-cooled chillers, condenser water supply temperature is used to estimate chiller power consumption. For air-cooled chillers, dry bulb temperature is used instead.",

    DryBulbDependencyHeating: "Dry bulb temperature is used to estimate the space heating load profile, while incoming cold water temperature is used to estimate the domestic hot water load profile.",
    WeatherDependencyHeating: "The weather parameters displayed above depend on the selected heating application.",

    CalibrationTitle: "Incomplete 4-Point Calibration Data",
    CalibrationNote:
      "The 4-point calibration data for the reference chiller is incomplete. Enter values for all four load points (25%, 50%, 75%, and 100%), or turn off 4-point calibration to continue.",
    CalibrationBack: "Back to Reference Chiller",

    SelectReportingFocus: "Select customer reporting focus",
    ROILedSummary: "ROI-led summary",
    EfficiencyLedSummary: "Efficiency improvement-led summary",
    ROILedNote: "Use when investment, savings, and payback results are strong enough to justify the project.",
    EfficiencyLedNote: "Use when efficiency improvement is the main justification, regardless of payback attractiveness.",
    ROILedNote_C: "Use when investment, savings, and payback are available.",
    EfficiencyLedNote_C: "Use when the decision is based mainly on efficiency improvement and ROI is unavailable or not meaningful.",

    ImgIgnoredWhenOffline: "Image operations will be ignored when offline"
  },

  placeholder: {
    PleaseInput: "Please input",
    SearchHere: "Search here",
    PleaseSelect: "Please select",
    SearchFilter: "Search & Filter",
    NotAvailable: "Not available",
    NoDataExist: "No data exist",
    NoDataAvailable: "No data available",
    NoChillerExist: "No chiller data exist",
    NoBaselineExist: "No baseline data exist",
    ClusterAutomaticallyMatches: "Automatically matches all operating periods",
    NoClusterExist: "No cluster months exist, please setting cluster months first",
    SelectTempCluster: "Please select cluster temperature",
    PleaseSelectInputFormat: "Please select or input, format: ",
    SearchFormat: "Search here, format: ",
    DigitalECatNotify: "Digital eCAT data is currently being integrated. Please use the manual cluster for now",

    AssumptionsPlaceholder:
      "Please outline the assumptions for the analysis. Specify the weather conditions considered, monthly operating equipment profile, and customer data shared during the interview. Alternatively, you may use the Template button for the standard description.",
    AssumptionsTemp:
      "Assumption analysis template: The analysis is based on [Chiller energy consumption / cooling capacity load data], which was estimated based on operational interviews. This data is used to estimate the monthly part-load performance of the existing [Enter chiller model] chiller by correlating it with local historical weather data for the corresponding period.\n\n\
(Optional: Use if chiller consumption is a percentage of total building energy)\n\
Chiller Energy Contribution:\n\
The chiller plant's energy consumption is assumed to be [Enter percentage, e.g., 45 %] of the total building energy use.\n\n\
The following operational parameters, confirmed with the customer's team, were used:\n\
Chiller Operating Schedule:\n\
[Number] chiller(s) run from[Month] to[Month]\n\
[Number] chiller(s) run from[Month] to[Month]",

    ObservationNote: "Keep only applicable bracketed options and verify all site information before saving.",
    Observation_chiller:
      "The existing chiller shows signs of aging and reduced efficiency. Site records indicate [frequent alarms / high power use / unstable operation / increasing maintenance needs], especially under [part-load / peak-load] conditions.",
    Recommendation_chiller:
      "Conduct a detailed performance test and verify operating setpoints, refrigerant condition, heat-transfer surfaces, and controls. Depending on the results, optimize operation or replace the unit with a high-efficiency variable-speed chiller.",
    Benefit_chiller:
      "Expected benefits include lower chiller energy use, improved part-load efficiency, fewer unplanned outages, reduced maintenance cost, and more stable chilled-water supply. A high-efficiency replacement may also reduce carbon emissions and improve long-term plant reliability.",
    Observation_pump:
      "The existing [chilled-water / condenser-water] pump operates at [fixed speed / an inefficient control point]. Flow appears higher than required during part-load operation, and [noise / vibration / leakage / unstable pressure] was observed.",
    Recommendation_pump:
      "Verify pump duty, flow, head, valve position, and system balance. Recommission the pump and control logic. Where feasible, install or enable a VFD and reset pump speed based on differential pressure or actual plant demand.",
    Benefit_pump:
      "The proposed action can reduce pumping energy, avoid excess flow and throttling losses, improve system delta-T and hydraulic stability, and reduce mechanical wear. Demand-based operation can also lower maintenance needs and improve overall chiller plant efficiency.",
    Observation_coolingTower:
      "The cooling tower shows [high approach temperature / fouled fill / uneven water distribution / poor fan control / visible scaling]. Condenser-water temperature is not consistently maintained at an efficient level.",
    Recommendation_coolingTower:
      "Inspect and clean the fill, basin, nozzles, strainers, and heat-transfer surfaces. Verify water treatment, airflow, and fan operation. Optimize staging and apply VFD control to maintain the required condenser-water temperature.",
    Benefit_coolingTower:
      "Improved tower performance can lower condenser-water temperature within safe operating limits, reduce chiller lift and energy use, stabilize plant operation, and reduce scaling or corrosion risk. Optimized fan control may also reduce tower energy and extend equipment life.",
    Observation_controlSys:
      "The existing control system mainly provides basic monitoring and does not fully optimize chiller, pump, and cooling-tower sequencing. Setpoints and equipment staging are [fixed / manually adjusted / not coordinated with load].",
    Recommendation_controlSys:
      "Upgrade or recommission the plant control system with demand-based sequencing, setpoint reset, equipment staging, alarm management, and performance monitoring. Calibrate key temperature, pressure, flow, and power sensors.",
    Benefit_controlSys:
      "Coordinated plant control can improve overall system efficiency by operating chillers, pumps, and cooling towers as one system. It can reduce unnecessary runtime, stabilize temperatures and flow, improve fault visibility, and support continuous performance tracking and energy optimization.",
    Observation_dryCooler:
      "The dry cooler shows [fouled coils / restricted airflow / damaged fins / high leaving-fluid temperature / poor fan control]. Fan operation is [fixed-speed / unstable], and heat-rejection performance appears inadequate under [part-load / peak-load] conditions.",
    Recommendation_dryCooler:
      "Inspect and clean the heat-transfer coils, straighten damaged fins, and remove airflow obstructions. Verify fluid flow, fan rotation, sensors, and controls. Optimize fan staging or apply VFD control based on leaving-fluid temperature and system demand.",
    Benefit_dryCooler:
      "Improved dry-cooler performance can reduce fluid temperature, improve system heat rejection, and lower fan and chiller energy use. Optimized fan control can reduce unnecessary runtime and noise, while regular coil maintenance helps maintain capacity, improve operating stability, and extend equipment life.",

    Observation_boiler:
      "Existing boiler provides [space heating/DHW]. Boiler operates on [fuel type] with [high fuel consumption/frequent cycling/high supply temperature/combustion inefficiency/leakage]. Limited monitoring or load-based optimization observed.",
    Recommendation_boiler:
      "Assess heating load, supply-water temperature, operating schedule, and terminal-unit requirements. Evaluate heat-pump suitability and determine whether the boiler should remain for peak-load or backup operation.",
    Benefit_boiler:
      "Heat-pump integration can reduce fuel consumption, carbon emissions, and operating costs while maintaining required heating performance. Proper load matching improves seasonal efficiency and may reduce reliance on fossil-fuel combustion. Retaining existing boilers only for peak or backup duty can minimize retrofit risk while supporting decarbonization objectives."
  },

  param: {
    hr: "Time",
    period: "Period",
    chCount: "chiller count in operations",
    maxLoad: "Max nominal load",
    percent: "Operating load",
    capacity: "Total operating load",
    consumption: "Energy consumption",
    existing: "Existing",
    proposed: "Proposed",
    assumptions: "Assumptions",
    energy: "Energy",
    maintenance: "Maintenance",
    repair: "Repair",
    other: "Others",
    discountRate: "Discount rate"
  },

  wizard: {
    navbar: {
      Wizard: "Wizard",
      MinimumInput: "Quick Setup",
      GenerateDefaults: "Generate initial defaults",
      ReviewAssumptions: "Review Assumptions",
      RunQuickCalculation: "Run quick calculation",
      ProposedSolution: "Assessment Results"
    },
    label: {
      ActualConditions: "Actual conditions",
      MonthlyAverageTariff: "Monthly average tariff",
      YearlyEnergyBill: "Annual energy bill",
      ReviewSection: "Review section",
      CoolingApplication: "Cooling Application Type",
      TemperatureSensitivityFactor: "Temperature Sensitivity Factor"
    },
    option: {
      PROCESS_COOLING: "Process cooling",
      DATA_CENTER: "Data center",
      ComfortCooling: "Comfort cooling",
      MixedUse: "Mixed use",
      ProcessDataCenter: "Process / Data Center",
      Custom: "Custom"
    },
    msg: {
      GeneratingDefaults: "Generating defaults...",
      RunningQuickCalculation: "Running quick calculation...",
      DataOverwriteWarning: "Data Overwrite Warning",
      PendingResultChangesWarning: "You've made changes on the review page, please trigger generating new results before proceeding.",
      RegenerateDefaultsWarning: "Regenerating the default values will permanently overwrite the current chart data on the review page. Do you wish to proceed?",
      PeriodCanNotAllOffEveryBaseline: "Period can not be all Off for each baseline"
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/en.js